import { Code } from '@chakra-ui/react';
import React from 'react';

interface Props {
  code: string;
}

const ContractVerificationFormCodeSnippet = ({ code }: Props) => {
  return (
    <Code
      as="pre"
      display="block"
      w="100%"
      whiteSpace="pre-wrap"
      wordBreak="break-all"
      p={ 2 }
      borderRadius="base"
      borderWidth="1px"
      borderColor="form_input_border"
      color="form_input_fg"
      bg="form_input_bg"
    >
      { code }
    </Code>
  );
};

export default React.memo(ContractVerificationFormCodeSnippet);
